import { useQuery } from '@tanstack/react-query';
import { BillingDetail } from './useBilling';

export const useBillingDetails = () =>
  useQuery<BillingDetail[]>({
    queryKey: ['admin', 'billing'],
  });
